import React, { useState, useEffect } from 'react'
import { ChevronDown } from 'lucide-react'

interface CollapsibleProps {
  title: string
  children: React.ReactNode
  defaultOpen?: boolean
  darkMode?: boolean
  expandTrigger?: number
  collapseTrigger?: number
}

export const Collapsible: React.FC<CollapsibleProps> = ({
  title,
  children,
  defaultOpen = true,
  darkMode = true,
  expandTrigger = 0,
  collapseTrigger = 0,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  useEffect(() => {
    if (expandTrigger > 0) setIsOpen(true)
  }, [expandTrigger])

  useEffect(() => {
    if (collapseTrigger > 0) setIsOpen(false)
  }, [collapseTrigger])

  return (
    <div
      className={`border-b last:border-0 transition-colors ${
        darkMode ? 'border-white/5' : 'border-slate-100'
      }`}
    >
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between py-4 group cursor-pointer"
      >
        <h3
          className={`text-[10px] font-black uppercase tracking-widest transition-colors ${
            darkMode
              ? 'text-slate-500 group-hover:text-white'
              : 'text-slate-400 group-hover:text-slate-900'
          }`}
        >
          {title}
        </h3>
        <div
          className={`p-1 rounded-md transition-all duration-300 ${
            isOpen ? 'rotate-180' : ''
          } ${
            darkMode
              ? 'bg-white/5 text-slate-600 group-hover:text-white group-hover:bg-white/10'
              : 'bg-slate-100 text-slate-300 group-hover:text-slate-900 group-hover:bg-white'
          }`}
        >
          <ChevronDown className="w-3.5 h-3.5" />
        </div>
      </button>
      <div
        className={`transition-all duration-500 ease-in-out ${
          isOpen ? 'max-h-[2000px] opacity-100 overflow-visible' : 'max-h-0 opacity-0 overflow-hidden'
        }`}
      >
        <div className="space-y-6 pb-6">{children}</div>
      </div>
    </div>
  )
}
